import {
  Button,
  CircularProgress,
  ListItemText,
  MenuItem,
  TableCell,
  TableRow,
  FormControl
} from "@mui/material";
import React, { useRef, useEffect, useState } from "react";
import configData from "../../config.json";
import Checkbox from "@mui/material/Checkbox";
import { GiSwan } from "react-icons/gi";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import "./CartRow.css";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { getToken } from "../../utils/auth"

export let device_floor_level = "***"
device_floor_level = "***"

export function CartRow({
  event,
  coordinates,
  updateCart,
  updateCartLocation,
  updateCenter,
  changeSelectedCart,
  isItemSelected,
  labelId,
  handleClick,
  columnForm,
  wasItemTriggered
}) {

  const params = useParams();
  const navigate = useNavigate();
  let strEventDate;
  if (event.journey_status === "offline") {
    strEventDate = moment(event.ts).format("YYYY-MM-DD HH:mm:ss");
  } else {
    strEventDate = moment(event.ts).format("HH:mm:ss");
  }
  const [location, setLocation] = useState(true);
  const [firstRun, setFirstRun] = useState(0);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const [cameraLoading, setCameraLoading] = useState(false);
  const [cameraStatus, setCameraStatus] = useState(null);
  const triggerDeviceCameras = () => {
    const token = getToken()
    setCameraLoading(true);
    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/tablet/trigger_camera/${event.device_id}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.front_camera === "Triggered") {
          const newMessage =
            String(event.device_id) + " front camera was triggered ";
          notify(newMessage, "success");
          setCameraLoading(false);
        } else {
          const newMessage =
            String(event.device_id) + " front camera failed to trigger ";
          notify(newMessage, "error");
          setCameraLoading(false);
        }
        if (data.back_camera === "Triggered") {
          const newMessage =
            String(event.device_id) + " back camera was triggered ";
          notify(newMessage, "success");
          setCameraLoading(false);
        } else {
          const newMessage =
            String(event.device_id) + " back camera failed to trigger ";
          notify(newMessage, "error");
          setCameraLoading(false);
        }
        if (
          data.back_camera === "Triggered" &&
          data.front_camera === "Triggered"
        ) {
          setCameraStatus("success");
        } else {
          setCameraStatus("failed");
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const handleClickOpen = (cart) => {
    navigate(`/Photos/` + cart.device_id + "/" + cart.serial_number);
  };

  //function for choosing to show indoorAtlas time or mdm time

  const handleLocation = () => {
    setLocation(!location);
  };

  const loadingRef = useRef(false);
  const [loadingLocation, setLoadingLocation] = useState(false);

  const showLocation = async () => {
    if (loadingRef.current) return; // ✅ prevents multiple calls immediately
    loadingRef.current = true;      // set the flag immediately
    setLoadingLocation(true);       // update state for UI feedback

    try {
      if (!location) {
        if (await updateCartLocation(event.serial_number, location)) {
          updateCenter(event.mdm_lat, event.mdm_lon);
        }
        else { setLocation(!location); }
      } else {
        event.mdm_location = false;
        const lat = coordinates[parseInt(params.retailer)][parseInt(params.store)]["lat"];
        const lng = coordinates[parseInt(params.retailer)][parseInt(params.store)]["lng"];
        updateCenter(lat, lng);
      }
    } finally {
      loadingRef.current = false;   // reset the ref after async call
      setLoadingLocation(false);   // reset UI
    }
  };
  useEffect(() => {
    if (firstRun === 0) {
      setFirstRun((prevState) => prevState + 1);
    } else {
      showLocation();
    }
  }, [location]);

  //move to singleCart page
  const moveToSingleCart = () => {
    navigate(
      `/cart/` +
      event.device_id +
      "/" +
      event.serial_number +
      "/" +
      params.retailer +
      "/" +
      params.store
    );
  };
  const setColor = (serial_number) => {
    let color = "#0000FF";
    changeSelectedCart(serial_number, color);
  };

  //Swan song functions
  const [songTrigger, setSongTrigger] = useState(null);
  const [swanMessage, setSwanMessage] = useState("Trigger swan song");
  const [messages, setMessages] = useState([
    "Trigger swan song",
    "Trigger search wifi networks",
  ]);
  const [openSwan, setOpenSwan] = useState(false);

  const handleSwanSongClick = () => {
    setSongTrigger({ response: "Loading" });
    setOpenSwan(false);
    const token = getToken()
    let device_id = event.device_id;
    let newBody = {
      tablets: [device_id],
      message: swanMessage,
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/Trigger/SwanSong`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setSongTrigger(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const handleSeeResultClick = () => {
    window.open(`/SwanSong/${event.device_id}`, '_blank');
  };

  const handleClickOpenSwan = () => {
    setOpenSwan(true);
  };

  const handleCloseSwan = () => {
    setOpenSwan(false);
  };
  //Beacon trigger functions
  const [beaconUuid, setBeaconUuid] = useState(null);
  const [beaconLoading, setBeaconLoading] = useState(false);
  const [beaconStatus, setBeaconStatus] = useState(null);
  const [beaconDialog, setBeaconDialog] = useState(false);
  const triggerDeviceBeacon = () => {
    const token = getToken()

    setBeaconLoading(true);
    let device_id = event.device_id;
    let newBody = {
      tablets: [device_id],
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/Trigger/Beacon`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.response === "Success") {
          setBeaconLoading(false);
          let message = "Beacon was triggered on " + device_id;
          notify(message, "success");
          setBeaconUuid(data);
          setBeaconStatus("Success");
        } else {
          setBeaconLoading(false);
          notify(data.response, "error");
          setBeaconStatus("Error");
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const beaconOpenDialog = () => {
    setBeaconDialog(true);
  };
  const beaconCloseDialog = () => {
    setBeaconDialog(false);
  };

  useEffect(() => {
    device_floor_level = "***"
  },
    []);
  return (
    <TableRow
      padding="none"
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      selected={event.color === "#0000FF" ? true : false}
      onClick={() => {
        if (device_floor_level !== event.floor_level) {
          device_floor_level = event.floor_level;
        }
        setColor(event.serial_number);
      }}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
    >
      <TableCell
        sx={{
          width: '0px',
        }}
        padding="checkbox">
        <Checkbox
          onClick={(e) => handleClick(e, event.serial_number)}
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      {columnForm.serial_number === true && (
        <TableCell component="th" scope="row" id={labelId}>
          <Button variant="outlined" size="small" onClick={moveToSingleCart}>
            {event.serial_number}
          </Button>
        </TableCell>
      )}
      {columnForm.battery === true && (
        <TableCell align="center">
          <ListItemText
            primary={`${event.battery}%`}
            secondary={moment(event.battery_ts).format("HH:mm:ss")}
          />
        </TableCell>
      )}
      {columnForm.battery_status === true && (
        <TableCell
          align="center"
          style={{
            color: event.battery_status === "CHARGING" ? "green" : "red",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            {event.battery_status === "CHARGING" ? (
              <span className="material-symbols-outlined">
                battery_charging_full
              </span>
            ) : event.battery_status === "UNKNOWN" ? (
              <span className="material-symbols-outlined">battery_unknown</span>
            ) : (
              <span className="material-symbols-outlined">battery_alert</span>
            )}

            {/* Temp below */}
            <span style={{ fontSize: "0.8em", marginTop: "4px" }}>
              {event.before_discharging_temp}
            </span>
          </div>
        </TableCell>
      )}
      {columnForm.battery_temp === true && (
        <TableCell align="center">
          <ListItemText primary={event.battery_temp} />
        </TableCell>
      )}
      {columnForm.wifi === true && (
        <TableCell align="center">
          {event.wifi === "WIFI" ? (
            <span
              className="material-symbols-outlined"
              style={{ color: "green" }}
            >
              wifi
            </span>
          ) : event.wifi === "4G" ? (
            <span
              className="material-symbols-outlined"
              style={{ color: "orange" }}
            >
              4g_mobiledata
            </span>
          ) : (
            <span
              className="material-symbols-outlined"
              style={{ color: "red" }}
            >
              signal_cellular_nodata
            </span>
          )}
        </TableCell>
      )}
      {columnForm.cart === true && (
        <TableCell>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Cart Icon */}
            {event.type === true ? (
              <ShoppingCartCheckoutIcon fontSize="large" style={{ color: "green" }} />
            ) : (
              <ShoppingCartIcon fontSize="large" style={{
                color: event.wifi === "WIFI" || event.wifi === "4G" ? "" : "red",
              }} />
            )}

            {/* WiFi icon + floor level stacked vertically */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              {event.wifi === "WIFI" ? (
                <span className="material-symbols-outlined" style={{ color: "green", fontSize: "15px" }}>
                  wifi
                </span>
              ) : event.wifi === "4G" ? (
                <span className="material-symbols-outlined" style={{ color: "orange", fontSize: "15px" }}>
                  4g_mobiledata
                </span>
              ) : (
                <span className="material-symbols-outlined" style={{ color: "red", fontSize: "15px" }}>
                  signal_cellular_nodata
                </span>
              )}
              <ListItemText
                primary={`${event.battery}%`}
                primaryTypographyProps={{ style: { fontSize: "10px", color: event.battery_status === "CHARGING" ? "green" : "red" } }}
              />
              <span>{`F ${event.floor_level}`}</span>
            </div>
          </div>
        </TableCell>
      )}
      {columnForm.tablet_status === true && (
        <TableCell>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Cart Icon */}
            {event.type === true ? (
              <ShoppingCartCheckoutIcon fontSize="large" style={{ color: "green" }} />
            ) : (
              <ShoppingCartIcon fontSize="large" style={{
                color: event.wifi === "WIFI" || event.wifi === "4G" ? "" : "red",
              }} />
            )}
          </div>
        </TableCell>
      )}

      {/* time stemp choose between indoorAtlas time or MDM time */}

      {columnForm.location_update === true && (
        <TableCell align="center">
          <ListItemText primary={strEventDate} />
        </TableCell>
      )}

      {/* fetches data from MDM about last location, wifi. battery
      <TableCell align="center">
        <Button
          variant="outlined"
          size="small"
          onClick={() => getCartLogs(event)}
        >
          MDM update
        </Button>
      </TableCell> */}

      {/* open a dialog to desplay a photo */}
      {columnForm.photo === true && (
        <TableCell align="center">
          <Button
            variant="outlined"
            size="small"
            onClick={triggerDeviceCameras}
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "36px" }}
            >
              photo_camera
            </span>
          </Button>
          {cameraLoading === true ? (
            <CircularProgress size={16} />
          ) : (
            cameraStatus && (
              <Button onClick={() => handleClickOpen(event)}>See result</Button>
            )
          )}
        </TableCell>
      )}
      {columnForm.show_location === true && (
        <TableCell align="center">
          <FormControl disabled={loadingLocation}>
            <RadioGroup
              value={event.mdm_location ? "gps" : "indoor"}
              onChange={() => handleLocation()}
            >
              {/* Indoor Radio */}
              <FormControlLabel
                sx={{ marginBottom: 0 }}
                value="indoor"
                control={<Radio size="small" />}
                label="Indoor Location"
              />

              {/* GPS Radio with Reload Button */}
              <FormControlLabel
                sx={{ marginBottom: 0 }}
                value="gps"
                control={<Radio size="small" />}
                label={
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span>GPS Location</span>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        showLocation();  // guard inside showLocation prevents multiple calls
                      }}
                      disabled={loadingLocation}    // UI disabled
                      style={{
                        background: "transparent",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        padding: 0,
                        margin: 0,
                        cursor: loadingLocation ? "not-allowed" : "pointer",
                        opacity: loadingLocation ? 0.5 : 1,
                      }}
                    >
                      {event.mdm_location && (
                        <img
                          src="/reload.png"
                          alt="reload"
                          style={{ width: 20, height: 20 }}
                        />
                      )}
                    </button>
                  </div>
                }
              />
            </RadioGroup>
          </FormControl>
        </TableCell>
      )}
      {columnForm.swan_song === true && (
        <TableCell align="center">
          <Button variant="outlined" size="small" onClick={handleClickOpenSwan}>
            <GiSwan style={{ fontSize: "42px", color: "black" }} />
          </Button>
          <Dialog open={openSwan} onClose={handleCloseSwan}>
            <DialogTitle>Trigger Swan Song</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please select what action you would like to do
                <br />
                Choose "Trigger Swan Song" to get images of front and back
                camera and list of wifi networks. <br />
                Choose "Trigger search wifi networks" to get only the wifi
                networks.
                <br />
                <br />
              </DialogContentText>
              <TextField
                id="outlined-select-currency"
                autoFocus
                fullWidth
                select
                label="Data"
                helperText="Please select data type"
                onChange={(e) => setSwanMessage(e.target.value)}
                value={swanMessage}
              >
                {messages.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseSwan}>Cancel</Button>
              <Button onClick={handleSwanSongClick}>Trigger</Button>
            </DialogActions>
          </Dialog>
          {songTrigger || wasItemTriggered ? (
            <>
              {(songTrigger?.response === "Loading") ? (
                <CircularProgress size={16} />
              ) : (songTrigger?.response === "Success" || wasItemTriggered || event.swan_song === true) ? (
                <Button onClick={handleSeeResultClick}>See result</Button>
              ) : (
                <Button onClick={handleSeeResultClick}>Failed</Button>
              )}
            </>
          ) : (
            event.swan_song === true && (
              <Button onClick={handleSeeResultClick}>See result</Button>
            )
          )}
        </TableCell>
      )}
      {/* Beacon trigger button */}
      {columnForm.beacon === true && (
        <TableCell align="center">
          <Button variant="outlined" size="small" onClick={triggerDeviceBeacon}>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "36px" }}
            >
              cell_tower
            </span>
          </Button>
          {beaconLoading === true ? (
            <CircularProgress size={16} />
          ) : (
            beaconStatus && (
              <>
                <Button onClick={beaconOpenDialog}>{beaconStatus}</Button>
                <Dialog open={beaconDialog} onClose={beaconCloseDialog}>
                  <DialogTitle>Beacon UUID</DialogTitle>
                  {beaconUuid && beaconStatus === "Success" && (
                    <DialogContent>
                      <DialogContentText>
                        {beaconUuid.uuid}
                        <br />
                        {new Date(beaconUuid.ts).toLocaleTimeString()}
                        <br />
                        Please notice that the Beacon is active for 5 minutes.
                        <br />
                      </DialogContentText>
                    </DialogContent>
                  )}
                  <DialogActions>
                    <Button onClick={beaconCloseDialog}>Cancel</Button>
                  </DialogActions>
                </Dialog>
              </>
            )
          )}
        </TableCell>
      )}
    </TableRow>
  );
}

export default CartRow;
